const BASE_URL = "https://api.seeandselect.com.pk";
//const BASE_URL = "http://localhost:4003";

export default BASE_URL;